import * as i18n from "../i18n.ts";
import * as FwDatas from "../FwDatas.ts";
import * as modal from "../util/modal.ts";

export async function familyPickOther(title){
  var otherFamilies = FwDatas.getFamilies().filter(family=>family.metaId!==FwDatas.getFamily().metaId);
  if(otherFamilies.length===1){
    return otherFamilies[0]
  }
  var picked = await modal.pick({
    title,
    button:otherFamilies.map(fam=>{
      return {
        title:fam.name,
        text:i18n.get('launchpad.member',fam.members.length),
        image:fam.coverUri+"&w=120&h=120&s=c",
        family:fam
      } 
    })
  })
  return picked?.family;
}